import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router';

/** Lets Astryx links/buttons with href navigate client-side; external URLs stay plain anchors. */
export const RouterLink = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string }>(
  function RouterLink({ href = '', ...rest }, ref) {
    const isInternal = href.startsWith('/') && !href.startsWith('//');
    if (!isInternal || rest.target === '_blank' || rest.download !== undefined) return <a ref={ref} href={href} {...rest} />;
    return <Link ref={ref} to={href} {...rest} />;
  },
);
